// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "app-launcher/actiondesk.e8bb8eb71183a78e34ea.min.js";
	if (chunkId === 9) return "app-launcher/static.777b44eaff97a62bf010.min.js";
	if (chunkId === 807) return "app-launcher/dynamic-locale-jp-json.97bb6f47bed0a2ce8217.min.js";
	if (chunkId === 138) return "app-launcher/md-editor.bcf587fc76a51a170098.min.js";
	if (chunkId === 176) return "app-launcher/charts.abc636091c40bfb6e189.min.js";
	if (chunkId === 522) return "app-launcher/maps.9764a4ac83dab9c3fd04.min.js";
	if (chunkId === 84) return "app-launcher/dendrogram.d41733d5d4eae97d0732.min.js";
	if (chunkId === 77) return "app-launcher/graph.86a1fcfe5d1f66426b16.min.js";
	if (chunkId === 108) return "app-launcher/sankey.83fd4f4f5de9a88f0cf6.min.js";
	if (chunkId === 293) return "app-launcher/293.f125596154ce51d916d9.min.js";
	if (chunkId === 163) return "app-launcher/163.991b568099d5f4b81b6e.min.js";
	if (chunkId === 628) return "app-launcher/628.a1c06bd792010b6c86a3.min.js";
	if (chunkId === 20) return "app-launcher/20.5fdda0f5d589fb157d48.min.js";
	if (chunkId === 262) return "app-launcher/262.396046a57c1c7eb10445.min.js";
	if (chunkId === 751) return "app-launcher/751.a6161c363a817401d0ae.min.js";
	// return url for filenames based on template
	return undefined;
};